import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    OvertimeListDDL: {},
    AssignmentListDDL: [],
    PossitionListDDL: [],
    CallbackMaxNumberDDL: [],
    OvertimeListArr: [],
    ShiftListDDL: [],
    DetailsListDDL: [],
    VendorListDDL: [],
    RankListDDL: [],
    EMTListDDL: [],
    EmployeesListDDL: [],
    TemplateListDDL: [],
    SelectOptionsListDDL: [],
    AbsentListDDL: [],
    FunctionListDDL: [],
    ConTypeDDL: [],
    CarrierDDL: [],
    EMTDDL: [],
    getOvertimeListsDDL :[],
};

export const ddlReducer = createSlice({
    name: "ddlReducer",
    initialState,
    reducers: {
        setOvertimeListDDL: (state, action) => {
            state.OvertimeListDDL = action.payload;
        },
        setOvertimeListArr: (state, action) => {
            let arr = [];
            Object.entries(action.payload).map((item) => {
                arr.push({ label: item[1], value: item[0] });
            });
            state.OvertimeListArr = arr;
        },
        setAssignmentListDDL: (state, action) => {

            state.AssignmentListDDL = action.payload
        },
        setPossitionListDDL: (state, action) => {

            state.PossitionListDDL = action.payload
        },
        setCallbackMaxNumberDDL: (state, action) => {

            state.CallbackMaxNumberDDL = action.payload
        },
        setShiftListDDL: (state, action) => {
            state.ShiftListDDL = action.payload;
        },
        setDetailsListDDL: (state, action) => {
            state.DetailsListDDL = action.payload;
        },
        setVendorListDDL: (state, action) => {
            state.VendorListDDL = action.payload;
        },
        setRankListDDL: (state, action) => {
            state.RankListDDL = action.payload;
        },
        setEMTListDDL: (state, action) => {
            state.EMTListDDL = action.payload;
        },
        setEmployeesListDDL: (state, action) => {
            state.EmployeesListDDL = action.payload;
        },
        setTemplateListDDL: (state, action) => {
            state.TemplateListDDL = action.payload;
        },
        setSelectOptionsListDDL: (state, action) => {
            state.SelectOptionsListDDL = action.payload;
        },
        setAbsentListDDL: (state, action) => {
            state.AbsentListDDL = action.payload;
        },
        setFunctionListDDL: (state, action) => {
            state.FunctionListDDL = action.payload;
        },
        setConTypeDDL: (state, action) => {
            state.ConTypeDDL = action.payload;
        },
        setCarrierDDL: (state, action) => {
            state.CarrierDDL = action.payload;
        },
        setEMTDDL: (state, action) => {
            state.EMTDDL = action.payload;
        },
        setOvertimeListsDDL : (state , action) => {
            state.getOvertimeListsDDL = action.payload;
        },
    },
});

export const { setOvertimeListDDL, setAssignmentListDDL, setPossitionListDDL, setCallbackMaxNumberDDL, setOvertimeListArr, setShiftListDDL, setDetailsListDDL, setVendorListDDL, setRankListDDL, setEMTListDDL, setEmployeesListDDL, setTemplateListDDL, setSelectOptionsListDDL, setAbsentListDDL, setFunctionListDDL, setConTypeDDL, setCarrierDDL, setEMTDDL, setOvertimeListsDDL } = ddlReducer.actions

export default ddlReducer.reducer;
